<template>
  <base-web-page>
    <template v-slot:main>
        <el-main style="margin:0 auto;max-width:1300px;width:100%;">
          <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:0px 5px;">
            <el-breadcrumb-item to="/account">My Account</el-breadcrumb-item>
            <el-breadcrumb-item>Order History</el-breadcrumb-item>
          </el-breadcrumb>
          <h1>Order History</h1>
          <el-radio-group v-model="activeStatus" fill="#303133">
            <el-radio-button label="paid"></el-radio-button>
            <el-radio-button label="delivered"></el-radio-button>
            <el-radio-button label="commented"></el-radio-button>
          </el-radio-group>
          <order-history :status="activeStatus"></order-history>
      </el-main>
    </template>
  </base-web-page>
</template>

<script>
import BaseWebPage from '../../components/base/BaseWebPage.vue'
import ModelOrders from '../viewmodel/ModelOrders.vue'
import OrderHistory from '../../components/widgets/OrderHistory.vue'

export default {
    extends: ModelOrders,
    name: 'orders',
    components: {
        BaseWebPage,
        OrderHistory
    }
}
</script>

<style>

</style>